import { SettingsPage } from 'user/pages'

export default function Settings() {
  return <SettingsPage />
}
